import { coalColor } from "../../../styles/theme";
import { IconProps } from "./";

export const CopyIcon = ({
  className,
  color = coalColor,
  size = 32,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.8001 12.3903C14.5998 11.5123 27.2001 12.3903 27.2001 12.3903C27.2001 12.3903 28.9999 22.9269 27.2001 26.439C25.4003 29.9512 12.8001 26.439 12.8001 26.439C12.8001 26.439 11.0005 13.2682 12.8001 12.3903Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M18.6667 7.94872C18.4581 5.89122 18.2168 4.38826 18.2168 4.38826C18.2168 4.38826 6.43141 3.51467 4.74813 4.38826C3.06484 5.26185 4.74813 18.3671 4.74813 18.3671C4.74813 18.3671 6.01204 18.2853 7.77117 18.6667"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
